require('../../modules/es6.object.is-frozen');
module.exports = require('../../modules/_core').Object.isFrozen;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/is-frozen.js
// module id = X9PN
// module chunks = 3